import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CreateWishlistModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: { customTopic: string; description: string }) => void;
    isSubmitting: boolean;
}

const CreateWishlistModal: React.FC<CreateWishlistModalProps> = ({
    isOpen,
    onClose,
    onSubmit,
    isSubmitting,
}) => {
    const { t } = useTranslation(['wishlist', 'common']);
    const [customTopic, setCustomTopic] = useState('');
    const [description, setDescription] = useState('');

    if (!isOpen) return null;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!customTopic.trim()) return;
        onSubmit({ customTopic: customTopic.trim(), description: description.trim() });
    };

    const handleClose = () => {
        setCustomTopic('');
        setDescription('');
        onClose();
    };

    return (
        <div className="wishlist-modal-overlay" onClick={handleClose}>
            <div className="wishlist-modal" onClick={(e) => e.stopPropagation()}>
                <div className="wishlist-modal__header">
                    <h2>{t('wishlist:createTitle')}</h2>
                    <button className="wishlist-modal__close" onClick={handleClose}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                            <path d="M5 5L15 15M15 5L5 15" />
                        </svg>
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="wishlist-modal__field">
                        <label>{t('wishlist:topicLabel')}</label>
                        <input
                            type="text"
                            value={customTopic}
                            onChange={(e) => setCustomTopic(e.target.value)}
                            placeholder={t('wishlist:topicPlaceholder')}
                            maxLength={255}
                            autoFocus
                        />
                    </div>

                    <div className="wishlist-modal__field">
                        <label>{t('wishlist:descriptionLabel')}</label>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder={t('wishlist:descriptionPlaceholder')}
                            maxLength={2000}
                            rows={3}
                        />
                    </div>

                    <div className="wishlist-modal__actions">
                        <button type="button" className="wishlist-modal__btn--cancel" onClick={handleClose}>
                            {t('common:cancel')}
                        </button>
                        <button
                            type="submit"
                            className="wishlist-modal__btn--submit"
                            disabled={!customTopic.trim() || isSubmitting}
                        >
                            {isSubmitting ? t('common:submitting') : t('wishlist:submit')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateWishlistModal;
